import { tw } from "@/utils";
import { InputHTMLAttributes } from "react";
import SearchIcon from "./search.svg?react";

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  fullWidth?: boolean;
  onSearch?: () => void;
}

export const SearchInput = (props: SearchInputProps) => {
  const { fullWidth, className, onSearch, ...otherprops } = props;

  return (
    <div className={tw("relative w-[350px] h-[42px]", fullWidth && "w-full")}>
      <input
        type="search"
        className={tw(
          "w-full h-full px-[15px] py-[6px] bg-white pl-[42px]",
          "border-[1px] border-solid border-gray-g50 rounded-[8px]",
          "text-base font-medium",
          "placeholder-gray-g100",
          className
        )}
        {...otherprops}
      />
      <button
        type="button"
        className="absolute left-[15px] top-1/2 -translate-y-1/2"
        onClick={onSearch}
      >
        <SearchIcon className="stroke-gray-g400" />
      </button>
    </div>
  );
};
